import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import FlywheelHeader from './flywheel/flywheelheader'
import DreamHostHeader from './dreamhost/dreamhostheader'
import CloudwaysHeader from './cloudways/cloudwaysheader'
import WPEngineHeader from './wpengine/wpengineheader'
import NexcessHeader from './nexcess/nexcessheader'
import PressableHeader from './pressable/pressableheader'
import WPCOMHeader from './wpcom/wpcomheader'
import MgHeader from './mg/mgheader'

class Header extends React.Component {
	constructor(props) {
		super(props)
		this.logo = this.logo.bind(this)
	}
	logo() {
		const { migrate } = this.props
		if (migrate.get('is_migrateguru')){
			return <img src="/assets/hostlogos/migrateguru.png" style={{marginTop:"-3.6rem", width:"11rem"}}/>
		}
		return <img src="/assets/new-logo.png" style={{width: "11rem"}}/>
	}
	render() {
		const { migrate } = this.props
		switch (migrate.get('origin')) {
		case ORIGIN.FLYWHEEL:
			return <FlywheelHeader />
		case ORIGIN.DREAMHOST:
			return <DreamHostHeader />
		case ORIGIN.CLOUDWAYS:
			return <CloudwaysHeader />
		case ORIGIN.WPENGINE:
			return <WPEngineHeader />
		case ORIGIN.LIQUIDWEB:
		case ORIGIN.NEXCESS:
			return <NexcessHeader />
		case ORIGIN.PRESSABLE:
			return <PressableHeader />
		case ORIGIN.AUTOMATTIC:
			return <WPCOMHeader />
		default:
			return <MgHeader migrate={migrate} logo={this.logo} />
		}
	}
}

Header.propTypes = {
	migrate: ImmutablePropTypes.map
}

export default Header
